var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: {
            title: "未成年人模式",
            "class-name": "vertical-center-modal my-modal modal-warp-set",
            "mask-closable": false,
            width: "700",
            "footer-hide": true
          },
          on: { "on-cancel": _vm.close },
          model: {
            value: _vm.modalShow,
            callback: function($$v) {
              _vm.modalShow = $$v
            },
            expression: "modalShow"
          }
        },
        [
          _c("div", { staticClass: "flex-box" }, [
            _c("div", { staticClass: "box-left" }, [
              _c("div", { staticStyle: { "text-align": "center" } }, [
                _c("img", {
                  staticStyle: {
                    display: "inline",
                    width: "40px",
                    height: "40px"
                  },
                  attrs: { src: require("../../assets/img/live/04.png") }
                })
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "p-title" }, [_vm._v("使用时间限制")]),
              _vm._v(" "),
              _c("p", { staticClass: "p-content" }, [
                _vm._v(
                  "每日22时至次日6时将无法使用，单日累计使用时长超过40分钟，需要输入监护密码才能继续使用"
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "p-title" }, [_vm._v("使用功能限制")]),
              _vm._v(" "),
              _c("p", { staticClass: "p-content" }, [
                _vm._v(
                  "无法进行充值打赏、购买兑换、弹幕评论、视频直播等互动性操作"
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "p-title" }, [_vm._v("观看内容限制")]),
              _vm._v(" "),
              _c("p", { staticClass: "p-content" }, [
                _vm._v(
                  "未成年人模式下，我们精选了一批教育类、知识类等适合未成年用户观看的优质内容"
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "p-title" }, [_vm._v("密码开启关闭")]),
              _vm._v(" "),
              _c("p", { staticClass: "p-content" }, [
                _vm._v(
                  "开启未成年人模式，需先设置监护密码，用于未成年人模式的开启与解除"
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "box-right" }, [
              _c("p", [_c("b", [_vm._v("设置密码")])]),
              _vm._v(" "),
              _c("p", { staticStyle: { "margin-bottom": "20px" } }, [
                _vm._v(
                  "启动末成年人模式，需先设置监护密码，用于未成年人模式的开启与解除"
                )
              ]),
              _vm._v(" "),
              _c("p", [_c("inputPwd", { ref: "inputPwdRef1" })], 1),
              _vm._v(" "),
              _c("p", { staticStyle: { "margin-top": "20px" } }, [
                _c("b", [_vm._v("确认密码")])
              ]),
              _vm._v(" "),
              _c("p", [_c("inputPwd", { ref: "inputPwdRef2" })], 1),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "tc", staticStyle: { "margin-top": "30px" } },
                [
                  _c(
                    "ButtonGroup",
                    { attrs: { shape: "circle" } },
                    [
                      _c(
                        "Button",
                        {
                          staticStyle: { width: "230px" },
                          attrs: { type: "warning" },
                          on: { click: _vm.saveConfig }
                        },
                        [_vm._v("开启未成年人模式")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "tc", staticStyle: { "margin-top": "10px" } },
                [
                  _vm._v("更多信息可阅读\n                    "),
                  _c(
                    "span",
                    {
                      staticStyle: { color: "#306cf4", cursor: "pointer" },
                      on: {
                        click: function($event) {
                          return _vm.goTo()
                        }
                      }
                    },
                    [_vm._v("《未成年模式使用须知》")]
                  )
                ]
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e3cef06", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e3cef06","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wcn/setB.vue
// module id = null
// module chunks = 